var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        "content-class": "fetching-spinner-content",
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "hide-header": "",
        "hide-footer": "",
        "hide-header-close": "",
      },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "default" }, slot: "default" },
        [
          _c("div", { staticClass: "loading-message" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.$t("uploading_photo")))]),
          ]),
          _vm._v(" "),
          _c("spinner-loader"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }